export default "__VITE_ASSET__lQZbTYqv__"